/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const cs_added_to_cart = /** @type {(inputs: {}) => string} */ () => {
	return `Přidáno do košíku`
};

const da_added_to_cart = /** @type {(inputs: {}) => string} */ () => {
	return `Lagt i kurv`
};

const de_added_to_cart = /** @type {(inputs: {}) => string} */ () => {
	return `Zum Warenkorb hinzugefügt`
};

const en_added_to_cart = /** @type {(inputs: {}) => string} */ () => {
	return `Added to the cart`
};

const es_added_to_cart = /** @type {(inputs: {}) => string} */ () => {
	return `Añadido al carrito`
};

const fr_added_to_cart = /** @type {(inputs: {}) => string} */ () => {
	return `Ajouté au panier`
};

const hu_added_to_cart = /** @type {(inputs: {}) => string} */ () => {
	return `Hozzáadva a kosárhoz`
};

const it_added_to_cart = /** @type {(inputs: {}) => string} */ () => {
	return `Aggiunto al carrello`
};

const nl_added_to_cart = /** @type {(inputs: {}) => string} */ () => {
	return `Toegevoegd aan winkelwagen`
};

const pl_added_to_cart = /** @type {(inputs: {}) => string} */ () => {
	return `Dodano do koszyka`
};

const pt_added_to_cart = /** @type {(inputs: {}) => string} */ () => {
	return `Adicionado ao carrinho`
};

const sv_added_to_cart = /** @type {(inputs: {}) => string} */ () => {
	return `Tillagd i kundvagnen`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "cs" | "da" | "de" | "en" | "es" | "fr" | "hu" | "it" | "nl" | "pl" | "pt" | "sv" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const added_to_cart = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.added_to_cart(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("added_to_cart", locale)
	if (locale === "cs") return cs_added_to_cart(inputs)
	if (locale === "da") return da_added_to_cart(inputs)
	if (locale === "de") return de_added_to_cart(inputs)
	if (locale === "en") return en_added_to_cart(inputs)
	if (locale === "es") return es_added_to_cart(inputs)
	if (locale === "fr") return fr_added_to_cart(inputs)
	if (locale === "hu") return hu_added_to_cart(inputs)
	if (locale === "it") return it_added_to_cart(inputs)
	if (locale === "nl") return nl_added_to_cart(inputs)
	if (locale === "pl") return pl_added_to_cart(inputs)
	if (locale === "pt") return pt_added_to_cart(inputs)
	return sv_added_to_cart(inputs)
};